import { CheckCircle, X } from "lucide-react";

export interface StringerAllocationUIProps {
  stringers: any[];
  availablePoints: string[];
  onPointChange: (stringerId: string, point: string) => void;
  onSave: () => void;
  onSkip?: () => void;
  isModal?: boolean;
}

export function StringerAllocationUI({
  stringers,
  availablePoints,
  onPointChange,
  onSave,
  onSkip,
  isModal = false
}: StringerAllocationUIProps) {

  const content = (
    <div style={{
      background: isModal ? 'var(--bg-secondary, #2A2438)' : 'transparent',
      borderRadius: isModal ? '16px' : '0',
      border: isModal ? '1px solid rgba(255,255,255,0.1)' : 'none',
      width: '100%',
      maxWidth: isModal ? '600px' : '100%',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: isModal ? '90vh' : 'auto',
      boxShadow: isModal ? '0 25px 50px -12px rgba(0, 0, 0, 0.5)' : 'none',
    }}>
      {isModal && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          padding: '20px 24px', 
          borderBottom: '1px solid rgba(255,255,255,0.1)' 
        }}>
          <h2 style={{ color: 'white', fontSize: '20px', fontWeight: 600, margin: 0 }}>
            Alocação Diária de Encordoadores
          </h2>
          {onSkip && (
            <button 
              onClick={onSkip} 
              style={{ background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.6)', cursor: 'pointer' }}
            >
              <X size={24} />
            </button>
          )}
        </div>
      )}

      <div style={{ padding: '24px', overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', margin: 0 }}>
          Por favor, confirme ou ajuste em qual(is) unidade(s) cada encordoador estará atuando.
        </p>

        {stringers.map(stringer => (
          <div key={stringer.id} style={{
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '12px',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
            <p style={{ color: 'white', fontWeight: 600, fontSize: '15px', margin: 0 }}>{stringer.name}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {availablePoints.map(point => {
                const isSelected = (stringer.stringingPoints || []).includes(point);
                return (
                  <button
                    key={point}
                    onClick={() => onPointChange(stringer.id, point)}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '20px',
                      fontSize: '13px',
                      fontWeight: 500,
                      cursor: 'pointer',
                      border: '1px solid',
                      transition: 'all 0.2s',
                      backgroundColor: isSelected ? 'var(--primary-color, #4ade80)' : 'rgba(255,255,255,0.1)',
                      borderColor: isSelected ? 'var(--primary-color, #4ade80)' : 'transparent',
                      color: isSelected ? '#000' : 'rgba(255,255,255,0.7)',
                    }}
                  >
                    {point}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div style={{ 
        padding: '16px 24px', 
        borderTop: isModal ? '1px solid rgba(255,255,255,0.1)' : 'none', 
        display: 'flex', 
        justifyContent: 'flex-end', 
        gap: '12px' 
      }}>
        {isModal && onSkip && (
          <button
            onClick={onSkip}
            style={{
              padding: '8px 16px',
              borderRadius: '8px',
              border: '1px solid rgba(255,255,255,0.2)',
              background: 'transparent',
              color: 'white',
              cursor: 'pointer',
              fontWeight: 500
            }}
          >
            Pular
          </button>
        )}
        <button
          onClick={onSave}
          className="button-primary"
          style={{
            padding: '8px 24px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontWeight: 600,
            fontSize: '14px',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          <CheckCircle size={18} />
          Salvar Alocação
        </button>
      </div>
    </div>
  );

  if (isModal) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '24px'
      }}>
        {content}
      </div>
    );
  }

  return content;
}
